import getBasePath from '../../../../common/functions/api-resource';

const basePath = getBasePath('apuracao', 'reprocessamento');

const apuracaoReprocessamentoActions = {
  reprocessar: { method: 'PUT', url: `${basePath}/{idMeta}/{tipoAcordo}/executar` },
};

export default resource => resource(`${basePath}`, {}, apuracaoReprocessamentoActions);



// WEBPACK FOOTER //
// ./src/custom/abbrasil/common/resources/apuracao-reprocessamento.js